// Search Modal Functions
function openSearchModal() {
  const overlay = document.querySelector('[data-search-modal-overlay]');
  const modal = document.querySelector('[data-search-modal]');

  if (!overlay || !modal) return;

  modal.classList.add('is-visible');
  overlay.classList.add('is-visible');
  document.body.style.overflow = 'hidden';

  const searchInput = modal.querySelector('[data-search-input-modal]');
  if (searchInput) {
    setTimeout(() => searchInput.focus(), 100);
  }

  if (window.modalSearch && searchInput && !searchInput.value.trim()) {
    window.modalSearch.showInitialState();
  }
}

function closeSearchModal() {
  const overlay = document.querySelector('[data-search-modal-overlay]');
  const modal = document.querySelector('[data-search-modal]');

  if (!overlay || !modal) return;

  modal.classList.remove('is-visible');
  overlay.classList.remove('is-visible');
  document.body.style.overflow = '';
}

// Cmd+K / Ctrl+K keyboard shortcut
document.addEventListener('keydown', function (e) {
  if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
    e.preventDefault();
    const modal = document.querySelector('[data-search-modal]');
    if (modal && modal.classList.contains('is-visible')) {
      closeSearchModal();
    } else {
      openSearchModal();
    }
  }
  if (e.key === 'Escape') {
    const modal = document.querySelector('[data-search-modal]');
    if (modal && modal.classList.contains('is-visible')) {
      closeSearchModal();
    }
  }
});

window.openSearchModal = openSearchModal;
window.closeSearchModal = closeSearchModal;

function initSearchModalListeners() {
  document.querySelectorAll('[data-search-modal-trigger]').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      openSearchModal();
    });
  });

  const closeButton = document.querySelector('[data-search-modal-close]');
  if (closeButton) {
    closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      closeSearchModal();
    });
  }

  const overlay = document.querySelector('[data-search-modal-overlay]');
  if (overlay) {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeSearchModal();
    });
  }

  const modal = document.querySelector('[data-search-modal]');
  if (modal) {
    modal.addEventListener('click', (e) => {
      const content = modal.querySelector('.search-modal__content');
      if (content && !content.contains(e.target)) {
        closeSearchModal();
      }
    });
  }
}

// ModalSearch class
if (!window.ModalSearch) {
  const RECENT_SEARCHES_KEY = 'tiles_recent_searches';
  const MAX_RECENT_SEARCHES = 5;

  class ModalSearch {
    constructor(modalElement) {
      this.modal = modalElement;
      this.input = this.modal.querySelector('[data-search-input-modal]');
      this.resultsContainer = this.modal.querySelector('[data-search-results-container-modal]');
      this.resultsContent = this.modal.querySelector('[data-search-results-content-modal]');
      this.loadingContainer = this.modal.querySelector('[data-search-loading-modal]');
      this.tabsContainer = this.modal.querySelector('[data-search-tabs]');
      this.typeInput = this.modal.querySelector('[data-search-type-input]');
      this.abortController = null;
      this.debounceTimer = null;
      this.currentQuery = '';
      this.activeIndex = -1;
      this.cachedResults = {};
      this.moneyFormat = this.modal.dataset.moneyFormat || '{{amount}}';
      this.translations = JSON.parse(this.modal.dataset.translations || '{}');
      this.popularProducts = this.parsePopularProducts();

      // Read search config from data attributes
      this.searchFields = this.modal.dataset.searchFields || 'title,product_type,tag,vendor,variants.title,variants.sku,variants.barcode,body';
      this.searchTypes = this.modal.dataset.searchTypes || 'product,collection,page,article';
      this.searchResultsLimit = parseInt(this.modal.dataset.searchResultsLimit, 10) || 10;
      this.showRecentSearches = this.modal.dataset.showRecentSearches !== 'false';

      // Build tab types from search types config
      this.tabTypes = this.searchTypes.split(',').map(t => t.trim() + 's');
      this.activeTab = this.tabTypes[0] || 'products';

      this.init();
    }

    init() {
      if (this.input && this.resultsContainer) {
        this.setupEventListeners();
        this.setupTabs();
      }
    }

    parsePopularProducts() {
      try {
        const data = JSON.parse(this.modal.dataset.popularProducts || '[]');
        return data.filter(p => p && p.title);
      } catch {
        return [];
      }
    }

    setupEventListeners() {
      this.input.addEventListener('input', () => {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => this.handleSearch(), 300);
      });

      this.input.addEventListener('keydown', (e) => {
        const items = this.resultsContent.querySelectorAll('[role="option"]');
        if (!items.length) return;

        if (e.key === 'ArrowDown') {
          e.preventDefault();
          this.activeIndex = Math.min(this.activeIndex + 1, items.length - 1);
          this.updateActiveDescendant(items);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          this.activeIndex = Math.max(this.activeIndex - 1, -1);
          this.updateActiveDescendant(items);
        } else if (e.key === 'Enter' && this.activeIndex >= 0) {
          e.preventDefault();
          const activeItem = items[this.activeIndex];
          if (activeItem && activeItem.href) {
            this.saveRecentSearch(this.input.value.trim());
            closeSearchModal();
            window.location.href = activeItem.href;
          }
        }
      });

      const form = this.input.closest('form');
      if (form) {
        form.addEventListener('submit', (e) => {
          const query = this.input.value.trim();
          if (!query) {
            e.preventDefault();
          } else {
            this.saveRecentSearch(query);
            closeSearchModal();
          }
        });
      }

      this.resultsContent.addEventListener('click', (e) => {
        const recentItem = e.target.closest('[data-recent-search]');
        if (recentItem) {
          e.preventDefault();
          this.input.value = recentItem.dataset.recentSearch;
          this.handleSearch();
          return;
        }
        const clearBtn = e.target.closest('[data-clear-recent]');
        if (clearBtn) {
          e.preventDefault();
          this.clearRecentSearches();
          this.showInitialState();
        }
      });
    }

    // --- Tabs ---
    setupTabs() {
      if (!this.tabsContainer) return;
      this.tabsContainer.addEventListener('click', (e) => {
        const tab = e.target.closest('[data-search-tab]');
        if (!tab) return;
        this.setActiveTab(tab.dataset.searchTab);
      });
    }

    setActiveTab(tabName) {
      if (!this.tabTypes.includes(tabName)) return;
      this.activeTab = tabName;

      // Update form hidden input for submit
      if (this.typeInput) {
        this.typeInput.value = tabName === 'articles' ? 'article' : tabName === 'pages' ? 'page' : tabName === 'collections' ? 'collection' : 'product';
      }

      // Update tab active state
      this.tabsContainer.querySelectorAll('[data-search-tab]').forEach(btn => {
        btn.classList.toggle('is-active', btn.dataset.searchTab === tabName);
      });

      // Render cached results for this tab
      this.renderActiveTab();
    }

    showTabs() {
      if (this.tabsContainer) this.tabsContainer.classList.remove('is-hidden');
    }

    hideTabs() {
      if (this.tabsContainer) this.tabsContainer.classList.add('is-hidden');
    }

    updateTabCounts() {
      this.tabTypes.forEach(type => {
        const countEl = this.tabsContainer.querySelector(`[data-tab-count="${type}"]`);
        if (countEl) {
          const results = this.cachedResults[type] || [];
          countEl.textContent = results.length > 0 ? results.length : '';
        }
      });
    }

    renderActiveTab() {
      const results = this.cachedResults[this.activeTab] || [];
      const query = this.currentQuery;

      if (results.length === 0) {
        this.resultsContent.innerHTML = `
          <div class="search-modal__empty-state">
            <p class="search-modal__empty-title">${this.translations.no_results_found || 'No results found'}</p>
            <p class="search-modal__empty-text">${this.translations.try_different_keywords || 'Try different keywords'}</p>
          </div>
        `;
        this.activeIndex = -1;
        return;
      }

      switch (this.activeTab) {
        case 'products':
          this.renderProductResults(results, query);
          break;
        case 'collections':
          this.renderCollectionResults(results, query);
          break;
        case 'pages':
          this.renderPageResults(results, query);
          break;
        case 'articles':
          this.renderArticleResults(results, query);
          break;
      }

      this.updateAriaExpanded(true);
      this.activeIndex = -1;
    }

    updateActiveDescendant(items) {
      items.forEach((item, i) => {
        if (i === this.activeIndex) {
          item.classList.add('is-active');
          item.scrollIntoView({ block: 'nearest' });
          this.input.setAttribute('aria-activedescendant', item.id || '');
        } else {
          item.classList.remove('is-active');
        }
      });
      if (this.activeIndex < 0) {
        this.input.removeAttribute('aria-activedescendant');
      }
    }

    // --- Recent Searches ---
    getRecentSearches() {
      try {
        return JSON.parse(localStorage.getItem(RECENT_SEARCHES_KEY)) || [];
      } catch {
        return [];
      }
    }

    saveRecentSearch(query) {
      if (!query || query.length < 2) return;
      let searches = this.getRecentSearches();
      searches = searches.filter(s => s.toLowerCase() !== query.toLowerCase());
      searches.unshift(query);
      searches = searches.slice(0, MAX_RECENT_SEARCHES);
      try {
        localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(searches));
      } catch {}
    }

    clearRecentSearches() {
      try { localStorage.removeItem(RECENT_SEARCHES_KEY); } catch {}
    }

    // --- Initial State ---
    showInitialState() {
      this.hideTabs();
      this.cachedResults = {};
      const recentSearches = this.getRecentSearches();
      let html = '';

      if (this.showRecentSearches && recentSearches.length > 0) {
        html += `<div class="search-modal__section">
          <div class="search-modal__section-header">
            <span class="search-modal__section-title">${this.translations.recent_searches || 'Recent searches'}</span>
            <button type="button" class="search-modal__clear-recent" data-clear-recent>${this.translations.clear_all || 'Clear all'}</button>
          </div>
          <div class="search-modal__recent-list">`;
        recentSearches.forEach(term => {
          html += `<button type="button" class="search-modal__recent-item" role="option" data-recent-search="${this.escapeHtml(term)}">
            <svg class="search-modal__recent-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            <span>${this.escapeHtml(term)}</span>
          </button>`;
        });
        html += `</div></div>`;
      }

      if (this.popularProducts && this.popularProducts.length > 0) {
        html += this.renderPopularProducts();
      }

      if (html) {
        this.resultsContent.innerHTML = html;
        this.updateAriaExpanded(true);
        if (this.resultsContainer) this.resultsContainer.classList.remove('is-hidden');
      }
    }

    renderPopularProducts() {
      const viewLabel = this.translations.view_product || 'View';

      let html = `<div class="search-modal__section">
        <span class="search-modal__section-title">${this.translations.popular_products || 'Popular products'}</span>
        <div class="search-modal__popular-scroll">
          <div class="search-modal__popular-track">`;

      this.popularProducts.forEach(product => {
        const imageUrl = product.image || '';
        const imageAlt = product.image_alt || product.title;
        const isOnSale = product.compare_at_price > 0 && product.compare_at_price > product.price;
        const priceDisplay = this.formatMoney(product.price);
        const compareDisplay = isOnSale ? this.formatMoney(product.compare_at_price) : '';
        const vendor = product.vendor || '';

        let savingsPercent = '';
        if (isOnSale && product.compare_at_price > 0) {
          const pct = Math.round(((product.compare_at_price - product.price) / product.compare_at_price) * 100);
          if (pct > 0) savingsPercent = `-${pct}%`;
        }

        html += `<a href="${product.url}" class="search-modal__popular-card" role="option">
          <div class="search-modal__popular-image-wrapper">
            ${imageUrl
              ? `<img src="${imageUrl}" alt="${this.escapeHtml(imageAlt)}" class="search-modal__popular-image" loading="lazy">`
              : `<div class="search-modal__popular-placeholder"><svg width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="m21 15-5-5L5 21"/></svg></div>`
            }
            ${isOnSale && savingsPercent ? `<span class="search-modal__popular-badge">${savingsPercent}</span>` : ''}
            <div class="search-modal__popular-overlay">
              <span class="search-modal__popular-overlay-text">${this.escapeHtml(viewLabel)}</span>
            </div>
          </div>
          <div class="search-modal__popular-info">
            ${vendor ? `<span class="search-modal__popular-vendor">${this.escapeHtml(vendor)}</span>` : ''}
            <span class="search-modal__popular-title">${this.escapeHtml(product.title)}</span>
            <div class="search-modal__popular-price-row">
              <span class="search-modal__popular-price${isOnSale ? ' search-modal__popular-price--sale' : ''}">${priceDisplay}</span>
              ${compareDisplay ? `<span class="search-modal__popular-compare">${compareDisplay}</span>` : ''}
            </div>
          </div>
        </a>`;
      });

      html += `</div></div></div>`;
      return html;
    }

    // --- Search (fetches all types) ---
    async handleSearch() {
      const query = this.input.value.trim();
      this.currentQuery = query;

      if (this.abortController) {
        this.abortController.abort();
      }

      if (!query || query.length < 2) {
        this.showInitialState();
        return;
      }

      this.showLoading();
      this.abortController = new AbortController();

      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=${this.searchTypes}&resources[limit_scope]=each&resources[limit]=${this.searchResultsLimit}&resources[options][fields]=${this.searchFields}`;
        const response = await fetch(url, {
          signal: this.abortController.signal,
          headers: { 'Accept': 'application/json' }
        });

        if (!response.ok) throw new Error('Search failed');

        const data = await response.json();
        const results = data?.resources?.results || {};

        this.cachedResults = {
          products: results.products || [],
          collections: results.collections || [],
          pages: results.pages || [],
          articles: results.articles || []
        };

        this.updateTabCounts();
        this.showTabs();

        // Auto-select first tab with results
        const hasResults = this.tabTypes.find(t => (this.cachedResults[t] || []).length > 0);
        if (hasResults && (this.cachedResults[this.activeTab] || []).length === 0) {
          this.setActiveTab(hasResults);
        } else {
          this.renderActiveTab();
        }
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Search error:', error);
          this.renderError();
        }
      } finally {
        this.hideLoading();
      }
    }

    updateAriaExpanded(expanded) {
      if (this.input) {
        this.input.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      }
    }

    // --- Price ---
    normalizeCents(value) {
      if (!value || value === 0) return 0;
      let price = typeof value === 'string' ? parseFloat(value) : Number(value);
      if (isNaN(price)) return 0;
      if (typeof value === 'string' && value.includes('.')) {
        price = Math.round(price * 100);
      } else if (price > 0 && price < 1000) {
        price = Math.round(price * 100);
      }
      return price;
    }

    highlightMatch(text, query) {
      if (!query || !text) return this.escapeHtml(text);
      const escaped = this.escapeHtml(text);
      const queryEscaped = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(`(${queryEscaped})`, 'gi');
      return escaped.replace(regex, '<mark class="search-modal__highlight">$1</mark>');
    }

    getMatchContext(product, query) {
      if (!query) return null;
      const q = query.toLowerCase();
      const titleMatch = product.title && product.title.toLowerCase().includes(q);

      if (product.variants && product.variants.length > 0) {
        const variant = product.variants[0];
        if (variant.title && variant.title.toLowerCase().includes(q)) {
          return { label: this.translations.match_variant || 'Variant', value: variant.title };
        }
        if (variant.title && !titleMatch) {
          return { label: this.translations.match_sku || 'SKU match', value: variant.title };
        }
      }

      if (product.tags && product.tags.length > 0) {
        const matched = product.tags.find(tag => tag.toLowerCase().includes(q));
        if (matched && !titleMatch) {
          return { label: this.translations.match_tag || 'Tag', value: matched };
        }
      }

      if (product.type && product.type.toLowerCase().includes(q) && !titleMatch) {
        return { label: this.translations.match_type || 'Category', value: product.type };
      }

      if (product.vendor && product.vendor.toLowerCase().includes(q) && !titleMatch) {
        return { label: this.translations.match_vendor || 'Brand', value: product.vendor };
      }

      return null;
    }

    // --- Product Results ---
    renderProductResults(products, query) {
      const resultsHTML = products.map((product, index) => {
        const imageUrl = product.image || '';
        const price = this.normalizeCents(product.price);
        const compareAtPrice = this.normalizeCents(product.compare_at_price);
        const isOnSale = compareAtPrice > 0 && compareAtPrice > price;
        const vendor = product.vendor || '';
        const productType = product.type || '';

        let priceDisplay = this.formatMoney(price);
        let comparePriceDisplay = isOnSale ? this.formatMoney(compareAtPrice) : '';

        const matchContext = this.getMatchContext(product, query);
        let metaParts = [];
        if (vendor) metaParts.push(this.escapeHtml(vendor));
        if (productType) metaParts.push(this.escapeHtml(productType));
        const metaLine = metaParts.join(' &middot; ');
        const matchingVariant = product.variants && product.variants.length > 0 ? product.variants[0] : null;

        return `
          <a href="${product.url}" class="search-modal__result-item" role="option" id="search-modal-result-${index}">
            ${imageUrl ? `
              <div class="search-modal__result-image-wrapper">
                <img src="${imageUrl}" alt="${this.escapeHtml(product.title)}" class="search-modal__result-image" loading="lazy">
              </div>
            ` : `
              <div class="search-modal__result-placeholder">
                <svg class="search-modal__result-placeholder-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"></path>
                </svg>
              </div>
            `}
            <div class="search-modal__result-details">
              ${metaLine ? `<span class="search-modal__result-meta">${metaLine}</span>` : ''}
              <h3 class="search-modal__result-title">${this.highlightMatch(product.title, query)}</h3>
              ${matchContext ? `
                <span class="search-modal__result-match">
                  <span class="search-modal__result-match-label">${this.escapeHtml(matchContext.label)}:</span>
                  ${this.highlightMatch(matchContext.value, query)}
                </span>
              ` : ''}
              ${matchingVariant && !matchContext ? `
                <span class="search-modal__result-match">
                  <span class="search-modal__result-match-label">${this.translations.match_variant || 'Variant'}:</span>
                  ${this.highlightMatch(matchingVariant.title, query)}
                </span>
              ` : ''}
              <div class="search-modal__result-price-group">
                ${isOnSale ? `
                  <span class="search-modal__result-price search-modal__result-price--sale">${priceDisplay}</span>
                  ${comparePriceDisplay ? `<span class="search-modal__result-compare-price">${comparePriceDisplay}</span>` : ''}
                ` : `
                  <span class="search-modal__result-price">${priceDisplay}</span>
                `}
              </div>
            </div>
          </a>`;
      }).join('');

      const seeMoreLink = this.currentQuery ? `
        <div class="search-modal__see-more">
          <a href="/search?q=${encodeURIComponent(this.currentQuery)}&type=product" class="search-modal__see-more-link" onclick="window.closeSearchModal();">
            ${this.translations.see_more || 'See more results'}
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
          </a>
        </div>` : '';

      this.resultsContent.innerHTML = resultsHTML + seeMoreLink;
    }

    // --- Collection Results ---
    renderCollectionResults(collections, query) {
      const html = collections.map((col, index) => {
        const imageUrl = col.featured_image ? col.featured_image.url : '';
        const body = col.body ? this.stripHtml(col.body).substring(0, 100) : '';

        return `
          <a href="${col.url}" class="search-modal__result-item" role="option" id="search-modal-result-${index}">
            ${imageUrl ? `
              <div class="search-modal__result-image-wrapper">
                <img src="${imageUrl}" alt="${this.escapeHtml(col.title)}" class="search-modal__result-image" loading="lazy">
              </div>
            ` : `
              <div class="search-modal__result-placeholder">
                <svg class="search-modal__result-placeholder-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/>
                </svg>
              </div>
            `}
            <div class="search-modal__result-details">
              <span class="search-modal__result-meta">${this.translations.tab_collections || 'Collection'}</span>
              <h3 class="search-modal__result-title">${this.highlightMatch(col.title, query)}</h3>
              ${body ? `<p class="search-modal__result-body">${this.escapeHtml(body)}${body.length >= 100 ? '...' : ''}</p>` : ''}
            </div>
          </a>`;
      }).join('');

      this.resultsContent.innerHTML = html;
    }

    // --- Page Results ---
    renderPageResults(pages, query) {
      const html = pages.map((page, index) => {
        const body = page.body ? this.stripHtml(page.body).substring(0, 120) : '';

        return `
          <a href="${page.url}" class="search-modal__result-item" role="option" id="search-modal-result-${index}">
            <div class="search-modal__result-placeholder">
              <svg class="search-modal__result-placeholder-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/>
              </svg>
            </div>
            <div class="search-modal__result-details">
              <span class="search-modal__result-meta">${this.translations.tab_pages || 'Page'}</span>
              <h3 class="search-modal__result-title">${this.highlightMatch(page.title, query)}</h3>
              ${body ? `<p class="search-modal__result-body">${this.escapeHtml(body)}${body.length >= 120 ? '...' : ''}</p>` : ''}
            </div>
          </a>`;
      }).join('');

      this.resultsContent.innerHTML = html;
    }

    // --- Article Results ---
    renderArticleResults(articles, query) {
      const html = articles.map((article, index) => {
        const imageUrl = article.image || (article.featured_image ? article.featured_image.url : '');
        const body = article.body ? this.stripHtml(article.body).substring(0, 120) : '';
        const author = article.author || '';

        return `
          <a href="${article.url}" class="search-modal__result-item" role="option" id="search-modal-result-${index}">
            ${imageUrl ? `
              <div class="search-modal__result-image-wrapper">
                <img src="${imageUrl}" alt="${this.escapeHtml(article.title)}" class="search-modal__result-image" loading="lazy">
              </div>
            ` : `
              <div class="search-modal__result-placeholder">
                <svg class="search-modal__result-placeholder-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
                </svg>
              </div>
            `}
            <div class="search-modal__result-details">
              <span class="search-modal__result-meta">${author ? this.escapeHtml(author) + ' &middot; ' : ''}${this.translations.tab_articles || 'Article'}</span>
              <h3 class="search-modal__result-title">${this.highlightMatch(article.title, query)}</h3>
              ${body ? `<p class="search-modal__result-body">${this.escapeHtml(body)}${body.length >= 120 ? '...' : ''}</p>` : ''}
            </div>
          </a>`;
      }).join('');

      this.resultsContent.innerHTML = html;
    }

    renderError() {
      this.resultsContent.innerHTML = `
        <div class="search-modal__empty-state">
          <p class="search-modal__empty-title">${this.translations.something_went_wrong}</p>
          <p class="search-modal__empty-text">${this.translations.please_try_again}</p>
        </div>
      `;
    }

    clearResults() {
      if (this.resultsContent) this.resultsContent.innerHTML = '';
      this.updateAriaExpanded(false);
      this.activeIndex = -1;
    }

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    stripHtml(html) {
      const div = document.createElement('div');
      div.innerHTML = html;
      return div.textContent || div.innerText || '';
    }

    formatMoney(cents) {
      const priceInCents = typeof cents === 'number' ? cents : parseFloat(cents) || 0;
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(priceInCents, this.moneyFormat);
      }
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }).format(priceInCents / 100);
    }

    showLoading() {
      if (this.loadingContainer) this.loadingContainer.classList.remove('is-hidden');
      if (this.resultsContainer) this.resultsContainer.classList.add('is-hidden');
    }

    hideLoading() {
      if (this.loadingContainer) this.loadingContainer.classList.add('is-hidden');
      if (this.resultsContainer) this.resultsContainer.classList.remove('is-hidden');
    }
  }

  function initModalSearch() {
    const modalElement = document.querySelector('[data-search-modal]');
    if (modalElement && !window.modalSearch) {
      window.modalSearch = new ModalSearch(modalElement);
    }
    initSearchModalListeners();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initModalSearch);
  } else {
    initModalSearch();
  }

  window.ModalSearch = ModalSearch;
}
